import ShopifyVariantPriceEdit from './ShopifyVariantPriceEdit'

export default function ShopifyVariantPriceView({
    variant,
    product,
    fetchProduct,
}) {
    const formatPrice = (price, currency = 'EUR') => {
        if (!price) return '-'

        const formatter = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            currency,
        })

        if (currency !== 'GBP') {
            return formatter.format(price) + ' HT'
        }

        return formatter.format(price) + ' TTC'
    }

    return (
        <div className="flex flex-col">
            <span>
                Prix Shopify : {formatPrice(variant.price, 'EUR')}
            </span>

            <span>
                Retail UK : {formatPrice(variant.price_gbp, 'GBP')}
            </span>

            <span>
                Retail US : {formatPrice(variant.price_usd, 'USD')}
            </span>

            <ShopifyVariantPriceEdit
                product={product}
                variant={variant}
                fetchProduct={fetchProduct}
            />
        </div>
    )
}